const palette = {
  neutral: {
    100: "#F3F4F6",
    200: "#E5E7EB",
    300: "#D1D5DB",
    400: "#9CA3AF",
    500: "#6B7280",
    600: "#4B5563",
    700: "#374151",
    800: "#1F2937",
    900: "#111827",
  },
  background: {
    default: "#F9FAFC",
    paper: "#FFFFFF",
  },
  divider: "#E6E8F0",
  primary: {
    main: "#F3DA00",
    light: "#FFDF95",
    dark: "#FFDF95",
    contrastText: "#000000",
  },
  secondary: {
    main: "#FFEF5A",
    light: "#FFF3D6",
    dark: "#FFE700",
    contrastText: "#000000",
  },
  grey: {
    main: "#4b4b4b",
    light: "#4b4b4b",
    dark: "#4b4b4b",
    contrastText: "#FFFFFF",
  },
  success: {
    main: "#14B8A6",
    light: "#43C6B7",
    dark: "#0E8074",
    contrastText: "#FFFFFF",
  },
  info: {
    main: "#2196F3",
    light: "#64B6F7",
    dark: "#0B79D0",
    contrastText: "#FFFFFF",
  },
  warning: {
    main: "#FFB020",
    light: "#FFBF4C",
    dark: "#B27B16",
    contrastText: "#FFFFFF",
  },
  error: {
    main: "#D14343",
    light: "#DA6868",
    dark: "#922E2E",
    contrastText: "#FFFFFF",
  },
  text: {
    primary: "#121828",
    secondary: "#65748B",
    disabled: "rgba(55, 65, 81, 0.48)",
  },
  action: {
    active: "#6B7280",
    focus: "rgba(55, 65, 81, 0.12)",
    hover: "rgba(55, 65, 81, 0.04)",
    selected: "rgba(55, 65, 81, 0.08)",
    disabledBackground: "rgba(55, 65, 81, 0.12)",
    disabled: "rgba(55, 65, 81, 0.26)",
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
}

export default palette
